export const bidProcessors = {
    publica: (bid = []) => {
        if (!bid || !Array.isArray(bid) || bid.length === 0) return {};
        // Process Publica-specific bid structure
        return bid.reduce((acc, item) => {
            if (item?.prebid?.targeting) {
                return { ...acc, ...item.prebid.targeting };
            }
            return acc;
        }, {});
    },
    aps: (bid = []) => {
        if (!bid || !Array.isArray(bid) || bid.length === 0) return {};
        // Process APS-specific bid structure
        return bid.reduce((acc, item) => {
            if (item) {
                const { amznactt, amznbid, amzniid, amznp, amznsz } = item || {};
                return { ...acc, amznactt, amznbid, amzniid, amznp, amznsz };
            }
            return acc;
        }, {});
    }
};
